document.addEventListener('DOMContentLoaded', function () {
  // ---- Quantity Buttons ----
  function createQuantityButtons() {
    const quantityInputs = document.querySelectorAll('.quantity input[type="number"]')
    quantityInputs.forEach((input) => {
      // Skip if buttons already exist
      if (input.parentNode.querySelector('.quantity-btn')) return

      const wrapper = input.parentNode
      const min = parseInt(input.getAttribute('min')) || 1
      const max = parseInt(input.getAttribute('max')) || 999

      // Create minus button
      const minusBtn = document.createElement('button')
      minusBtn.type = 'button'
      minusBtn.className = 'quantity-btn minus'
      minusBtn.innerHTML = '−'
      minusBtn.setAttribute('aria-label', 'Decrease quantity')

      // Create plus button
      const plusBtn = document.createElement('button')
      plusBtn.type = 'button'
      plusBtn.className = 'quantity-btn plus'
      plusBtn.innerHTML = '+'
      plusBtn.setAttribute('aria-label', 'Increase quantity')

      // Add class to input
      input.classList.add('qty')

      // Insert buttons
      wrapper.insertBefore(minusBtn, input)
      wrapper.appendChild(plusBtn)

      // Button functionality
      minusBtn.addEventListener('click', function () {
        const currentValue = parseInt(input.value) || min
        if (currentValue > min) {
          input.value = currentValue - 1
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })

      plusBtn.addEventListener('click', function () {
        const currentValue = parseInt(input.value) || min
        if (currentValue < max) {
          input.value = currentValue + 1
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })

      // Update button states
      function updateButtonStates() {
        const currentValue = parseInt(input.value) || min
        minusBtn.disabled = currentValue <= min
        plusBtn.disabled = currentValue >= max
      }

      // Initial state
      updateButtonStates()

      // Update on input change
      input.addEventListener('input', updateButtonStates)
      input.addEventListener('change', updateButtonStates)
    })
  }

  // ---- Initialize on page load ----
  createQuantityButtons()

  // ---- Re-initialize when AJAX fragments are loaded ----
  document.body.addEventListener('updated_wc_div', createQuantityButtons)
  document.body.addEventListener('wc_fragments_refreshed', createQuantityButtons)

  // For older WooCommerce events
  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(document).on('updated_cart_totals', function () {
      setTimeout(createQuantityButtons, 100)
    })
    window.jQuery(document).on('updated_checkout', function () {
      setTimeout(createQuantityButtons, 100)
    })
  }

  // ---- Fallback for cart form updates (MutationObserver) ----
  const cartForm = document.querySelector('form.woocommerce-cart-form')
  if (cartForm) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setTimeout(createQuantityButtons, 50)
        }
      })
    })
    observer.observe(cartForm, { childList: true, subtree: true })
  }

  // ---- Force full page reload on Update Cart ----
  document.body.addEventListener('click', function (e) {
    const updateBtn = e.target.closest('button[name="update_cart"], input[name="update_cart"]')
    if (updateBtn) {
      // Let WooCommerce process form submission, but as a fallback, force reload after a short delay
      setTimeout(function () {
        window.location.reload()
      }, 600)
    }
  })
})
